import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=2e85d521&scoped=true&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=2e85d521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85d521",
  null
  
)

export default component.exports